import type { Schema } from '@fhs/client';

import { CartOfferItem as CartOfferTypeItem } from './offer-item';
import { CartRewardItem } from './reward-item';

type Props = {
  incentive: Schema['CartIncentive']['type'];
  entries: (Schema['CartItemEntry']['type'] & { quantity: number })[];
};

export function CartOfferItem(props: Props) {
  switch (props.incentive.type) {
    case 'REWARD':
      return <CartRewardItem incentive={props.incentive} entry={props.entries[0]} />;
    default:
      return <CartOfferTypeItem incentive={props.incentive} entries={props.entries} />;
  }
}
